export default "__VITE_ASSET__3eba7c7a__"